export const transitions = {
    fast: '0.15s ease',
    normal: '0.2s ease',
    slow: '0.3s ease',
    bounce: '0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
    color: '0.2s ease',
    transform: '0.2s ease',
    opacity: '0.2s ease',
    all: '0.2s ease-in-out',
};
